import React, { FunctionComponent } from 'react';

import styles from './TimelineIndicator.module.scss';

export enum TimelineStepStatus {
  'upcoming',
  'active-long',
  'active-medium',
  'active-short',
  'completed',
}

interface TimelineIndicatorProps {
  isLast?: boolean;
  timeIndication?: TimelineStepStatus;
}

const TimelineIndicator: FunctionComponent<TimelineIndicatorProps> = ({
  isLast = false,
  timeIndication = TimelineStepStatus.upcoming,
}) => {
  const wrapperClasses = [styles.indicatorWrapper, styles[`indicationTime-${timeIndication}`]];

  if (isLast) {
    wrapperClasses.push(styles.last);
  }

  return (
    <div className={wrapperClasses.join(' ')}>
      <div className={styles.indicatorBox}>
        <div className={styles.indicator} />
      </div>
    </div>
  );
};

export default TimelineIndicator;
